/* eslint-disable no-prototype-builtins */
/* eslint-disable no-self-assign */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef, EventEmitter, Output, ChangeDetectionStrategy, SimpleChanges, ElementRef, ViewChildren, QueryList } from '@angular/core';
import { DataFormatterService } from 'src/app/common/data-formatter.service';
import { Chart, registerables, } from 'chart.js';
import { UtilsService } from '../../services/utils.service';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { ChartService } from '../../services/chart.service';
import { DataService } from '../../services/data.service';
import { UserService } from '../../services/user.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FilterResultService } from '../../services/filter-result/filter-result.service';
import { ProcessType } from '../../configs/process-type.config';
import { IonModal } from '@ionic/angular';
import { debounceTime } from 'rxjs/operators';

Chart.register(...registerables);
Chart.register(ChartDataLabels);

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultComponent implements OnInit, AfterViewInit {

  @Input() results: any = [];
  @Input() graphDatasets: any = {};
  @Input() generatedSql: any = "";
  @Input() resultIndex: any = 1;
  @Input() answerMode: any;
  @Input() prompt?:any=[];
  @Input() question: any;
  @Input() filterEnabled: any;
  @Input() trainingInfo:boolean=false
  @Input() qid?:any;
  @Input() feedback?:any=0;
  @Input() trainingDataId?:any;
  @Input() processType?:any;
  @Input() tokens?:any;

  @Output() filterPanel: EventEmitter<{ chart?: any, id?: any, resultIndex?: any,qid?:any }> = new EventEmitter();


  @ViewChild('chartCanvas') chartCanvas: any;
 
  @ViewChild('chartCanvas2', { static: false })
  chartCanvas2!: ElementRef<HTMLCanvasElement>;
  @ViewChild('modal')
  modal!: IonModal;

  

  @ViewChild('menuTrigger') trigger: any;
  errorMessage: string | null = null;
  likeImage: string = 'right-inactive';
  disLikeImage: string = 'wrong-inactive';
  settingsList: string[] = ['Sentence', 'Table', 'Graph', 'Copy', 'Download'];
  labelRangeList: string[] = ['0-30', '0-60', 'All'];
  chartType: 'bar' | 'line' | 'pie' | 'polarArea' = 'bar';
  selectedLabel: string | null = null;
  settingMode = this.userService.getAnswerMode();

  chart: any;
  graphDisabled: boolean = false;
  graphDataLoaded: boolean = true;
  labels100: boolean = false;
  labels30: boolean = true;
  graphNotFound: boolean = false;
  trainerMode: boolean = false;
  isLiked: boolean = false;
  isDisliked: boolean = false;
  filterDataLoaded: boolean=false;
  trainerIdInfo:any=[]
  expandMore:boolean=false;
  private initialized = false;
  showMessage=false;
  showRightMessage=false;
  showWrongMessage=false;
  public rightProgress = 0;
  public wrongProgress = 0;
  feedbackMessage:string="";
  private rightProgressInterval: any;
private wrongProgressInterval: any;  
private rightCompleteTimeout: any;
private wrongCompleteTimeout: any;
  

  


  constructor(private dfs: DataFormatterService, private cdr: ChangeDetectorRef, public us: UtilsService, public chartService: ChartService, private dataService: DataService, private userService: UserService,private filterResultService:FilterResultService) {

  }

  async ngOnInit() {
  if (this.initialized) return;
  this.initialized = true;
    this.formatResults();
    this.graphDisabled = false;

    if (!this.results.error) {
     
      this.onClickSetting()
     
    }
    if (this.generatedSql == undefined) {
      this.graphDisabled = true;
    }

  
    this.updateFeedback()
   
    this.trainerMode = this.userService.getTrainerMode();
   
  }
   ngOnChanges(changes: SimpleChanges){
    this.updateFeedback()
   
   }
  getTrainingInfo(){
   
     if(this.trainingDataId!=undefined){
      this.us.getVersions(this.trainingDataId,this.resultIndex)   
     }
  }
  ngAfterViewInit() {
  
  }

  getKeys(item: any): string[] {
    return Object.keys(item);
  }
  updateFeedback(){
    if( this.feedback==1){
      this.likeImage = 'right-active';
    this.disLikeImage = 'wrong-inactive';
    this.us.detailsEdit=true
    }
    else if( this.feedback==0){
      this.likeImage = 'right-inactive';
      this.disLikeImage = 'wrong-active';
      this.us.detailsEdit=true
    }
    else{
      this.likeImage='right-inactive';
      this.disLikeImage= 'wrong-inactive';
      this.us.detailsEdit=true
    }
   
   }
  formatResults() {
    if (!this.results?.error) {
      this.results = this.dfs.formatResults(this.results);

      

    } else {
      this.errorMessage = this.results.error;
    }
    
  }

  sortResultsByNumber() {
    if (!this.results?.error) {
      this.results = this.dfs.sortResultsByNumber(this.results);
      this.cdr.detectChanges();
    } else {
      this.errorMessage = this.results.error;
    }
  }

  likeResponse() {
    this.likeImage = 'right-active';
    this.disLikeImage = 'wrong-inactive';
 
    if(this.trainingDataId==undefined){
    this.dataService.postTrainingData(this.us.generatedQuestion,this.us.generatedSql,this.us.generatedPrompt!=''?JSON.parse(this.us.generatedPrompt):"",1).subscribe((res)=>{
     
      this.trainingDataId=res.training_data_id
      this.us.getVersions(res.training_data_id,this.resultIndex)
      this.us.detailsChanged=false;
      this.updateTrainingId(res.training_data_id,1)
  
    })
  }
  else{
    let body={}
    if(this.us.detailsChanged){
      body={
        "question": this.us.generatedQuestion,
        "sql_query": this.us.generatedSql,
        "promt": this.us.generatedPrompt!=''?JSON.parse(this.us.generatedPrompt):"",
        "trainer_id": this.userService.getUserId(),
        "feedback": 1,
        "org_id": this.userService.getOrgId()==0?1:this.userService.getOrgId()
    }

    this.dataService.updateTrainingData(this.trainingDataId,body).subscribe((res)=>{
        
      this.us.getVersions(this.trainingDataId,this.resultIndex,true)
      this.us.detailsChanged=false
    })
    }
    else{
      body={
        "question": this.us.generatedQuestion,
        "trainer_id": this.userService.getUserId(),
        "feedback": 1,
        "version_number":this.us.selectedVersion,
        "org_id": this.userService.getOrgId()==0?1:this.userService.getOrgId()
    }

    this.dataService.updateTrainingData(this.trainingDataId,body).subscribe((res)=>{
        
      this.us.getVersions(this.trainingDataId,this.resultIndex,false)
      this.us.detailsChanged=false
    })
    }
   
  }

    this.us.detailsEdit = true
  this.feedbackMessage="This one’s saved! I’ll rely on it when you ask something like this again."
  this.showRightResponseMessage() 

  }
  

  disLikeResponse() {
    
    this.likeImage = 'right-inactive';
    if (this.disLikeImage === 'wrong-active') {
      this.disLikeImage = 'wrong-inactive'
      this.us.detailsEdit = false
    }
    else {
      this.disLikeImage = 'wrong-active'
      this.us.detailsEdit = true
   
    }
    if(this.trainingDataId==undefined){
    
      this.dataService.postTrainingData(this.us.generatedQuestion,this.us.generatedSql,this.us.generatedPrompt!=''?JSON.parse(this.us.generatedPrompt):"",0).subscribe((res)=>{
        this.trainingDataId=res.training_data_id
        this.us.getVersions(res.training_data_id,this.resultIndex)
        this.us.detailsChanged=false;
        this.updateTrainingId(res.training_data_id,0)
      })
    }
    else{
      let body={}
    if(this.us.detailsChanged){
      body={
        "question": this.us.generatedQuestion,
        "sql_query": this.us.generatedSql,
        "promt": this.us.generatedPrompt!=''?JSON.parse(this.us.generatedPrompt):"",
        "trainer_id": this.userService.getUserId(),
        "feedback": 0,
        "org_id": this.userService.getOrgId()==0?1:this.userService.getOrgId()
    }

    this.dataService.updateTrainingData(this.trainingDataId,body).subscribe((res)=>{
        
      this.us.getVersions(this.trainingDataId,this.resultIndex,true)
      this.us.detailsChanged=false
    })
    }
    else{
      body={
        "question": this.us.generatedQuestion,
        "trainer_id": this.userService.getUserId(),
        "feedback": 0,
       "version_number":this.us.selectedVersion,
       "org_id": this.userService.getOrgId()==0?1:this.userService.getOrgId()
    }

    this.dataService.updateTrainingData(this.trainingDataId,body).subscribe((res)=>{
        
      this.us.getVersions(this.trainingDataId,this.resultIndex,false)
      this.us.detailsChanged=false
    })
    }

    }
  this.feedbackMessage="Thanks for the correction. I’ve deleted the saved result and will reprocess your question."
  this.showWrongResponseMessage() 

  }

  onClickSetting() {
    const { numberKeys } = this.chartService.separateData(this.results);
    if (numberKeys.length === 0 || (Object.keys(this.results[0]).length == 1 && this.results.length == 1)) {
      this.graphDisabled = true;
    }
    this.setAnswerMode();
  }
  async setAnswerMode() {
      this.settingMode = await this.answerMode;
      this.cdr.detectChanges();
   
    if (this.settingMode == 'Graph') {
      this.graphDataLoaded = false;
      this.cdr.detectChanges()
      this.getGraPH(true)
    }
  }

  async selectSettingMode(item: string) {
    this.graphDataLoaded = true;
    this.cdr.detectChanges();
    if (item === 'Graph') {
      this.graphDataLoaded = false;
      this.us.addConversationMessages(this.resultIndex, item)
      if (this.settingMode !== item) {
        this.settingMode = item;
        this.getGraPH(true)
      }
      else {
        this.graphDataLoaded = true;
      }
    }

    else if (item === 'Download') {

      if (this.settingMode === 'Graph') {

        this.downloadCanvasAsImage()
      }
      else {
        this.downloadTableToCSV();
      }
    }
    else if (item === 'Copy') {
      this.copyTableToClipboard()
    }


    else {
      this.us.addConversationMessages(this.resultIndex, item)
      this.settingMode = 'Table'
    }
    
  }
  async getGraPH(creatChart:boolean) {
   if(!this.graphDataLoaded){
    this.labels100 = false;
    this.labels30 = true;
   }
   if(!this.graphDisabled){
    try {
      const res = await this.dataService.getGraph(this.generatedSql).toPromise();
      if (res && res.metadata) {
        this.graphDatasets = res.metadata;
        this.graphDataLoaded = true;
        this.cdr.detectChanges()
        this.filterDataLoaded=true;
        if(creatChart){

        this.createChart();
        }
        this.us.filterDataNotFound=false;
        this.us.saveGraphData(this.resultIndex, this.chart, this.graphDatasets, );
        
      } else {

        throw new Error('No metadata returned from the graph API');
      }
    } catch (error) {
      this.us.filterDataNotFound=true; 
      this.us.filterDataLoaded=true;
      this.graphNotFound = true
      this.graphDataLoaded=true;
      this.cdr.detectChanges()
     
      
      console.error('Error fetching graph data:', error);
    
  }
}
else{
  this.us.filterDataNotFound=true; 
  this.us.filterDataLoaded=true;
  this.graphNotFound = true
  this.graphDataLoaded=true;
  this.cdr.detectChanges()
}
  }
  async createChart() {
    this.chart = this.chartService.createChart(this.results, this.graphDatasets, this.chartCanvas,);
    this.chartType = this.chartService.chartType
    if(this.us.filterMenuOpen==true){
      this.filterPanel.emit({ chart: this.chart,id:`message-${this.resultIndex}`,resultIndex:this.resultIndex });
    }
    if (this.chartService.xLabels && this.chartService.xLabels.length <= 3) {
      this.labels100 = false;
      this.labels30 = true;
      this.cdr.detectChanges()
    }
    else {
      this.labels100 = false;
      this.labels30 = false;
      this.cdr.detectChanges();
    }
  
  }

  downloadTableToCSV() {

    if (!this.results || this.results.length === 0) return;
    const headers = Object.keys(this.results[0]);
    const rows = this.results.map((item: { [x: string]: any; }) => headers.map(header => item[header]));
    let csvContent = headers.join(',') + '\n';
    rows.forEach((row: any[]) => {
      csvContent += row.join(',') + '\n';
    });
    this.saveFile(csvContent, 'result_data.csv');
  }
  copyTableToClipboard() {
    if (!this.results || this.results.length === 0) return;
    const headers = Object.keys(this.results[0]);
    const rows = this.results.map((item: { [key: string]: any }) => headers.map(header => item[header]));
    let csvContent = headers.join(',') + '\n';
    rows.forEach((row: any[]) => {
      csvContent += row.join(',') + '\n';
    });
    navigator.clipboard.writeText(csvContent).then(() => {
      alert('Table content copied to clipboard!');
    }).catch((err) => {
      console.error('Error copying to clipboard:', err);
      alert('Failed to copy to clipboard');
    });
  }

  saveFile(data: string, filename: string): void {
    const blob = new Blob([data], { type: 'text/csv' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
  }

  downloadCanvasAsImage() {
    const canvas = this.chartCanvas?.nativeElement;

    if (canvas && typeof canvas.toDataURL === 'function') {
      const dataURL = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = dataURL;
      link.download = 'chart-image.png';
      link.click();
    } else {
      console.error('Canvas element or toDataURL method not found.');
    }
  }
  async openFilterMenu() {
    this.us.promptDataLoaded=false 
    this.us.questionId=this.qid
    this.us.token=this.tokens
    if(this.us.trainerMode){ 
      if(this.processType.length==0){
        this.us.updatedProcessTypes=ProcessType
      }
      this.us.promptMenuOpen=true
      this.us.activeTabIndex=0
     
    if(this.trainingDataId!=undefined){
      this.us.getVersions(this.trainingDataId,this.resultIndex)
    }
    else{
      this.us.currentVersion=0
      this.us.selectedVersion=0
    
    }
    if(this.us.trainedQuestions.length!==0 && this.us.trainedQuestions.length!==undefined &&this.us.trainerMode){
      this.us.getTrainedPromptDetails(this.question!,this.qid!)  
      }
  }
    if(!this.graphDisabled){
    this.us.filterDataLoaded=false
    this.us.filterMenuOpen=true
   
    this.us.updateResults(this.resultIndex) 
    if(!this.filterDataLoaded){

      await this.getGraPH(false)
      this.filterPanel.emit({ chart: this.chart,id:`message-${this.resultIndex}`,resultIndex:this.resultIndex,});
    
    }else{
      this.filterPanel.emit({ chart: this.chart,id:`message-${this.resultIndex}`,resultIndex:this.resultIndex ,});
    
       
    }
   
  
   
  }
  else{
    this.us.filterMenuOpen=true
    this.us.filterDataLoaded=true
    this.us.filterDataNotFound=true
    this.us.updateResults(this.resultIndex)
      this.filterPanel.emit({ resultIndex: this.resultIndex, });
  }
  }
  updateTrainingId(trainingID:any,feedback:number) {
   
    this.us.updatedChatMessages = this.us.updatedChatMessages.map(item => {
  
      if (item.hasOwnProperty('resultIndex') && item.resultIndex === this.resultIndex) {
      
        return {
          ...item,  
          trainingInfo:true, 
          feedback:feedback,          
          trainingDataID:trainingID 
        };
      }
      return item; 
    });
  }
  async expandRows(){
   
    this.expandMore=!this.expandMore
    if(this.settingMode=='Graph'){
      const graphData=this.filterResultService.getGraphData(`message-${this.resultIndex}`)
  
      this.cdr.detectChanges()
   
    
      const modal = await this.modal.present();
      const canvas = this.chartCanvas2.nativeElement;
    
    }
  }
  showRightResponseMessage() {
    
    clearInterval(this.wrongProgressInterval);
    clearInterval(this.rightProgressInterval);
    clearTimeout(this.rightCompleteTimeout);
    
    
    this.rightProgress = 0;
    this.showWrongMessage = false;
    this.showRightMessage = true;
    this.cdr.detectChanges();

    const totalDuration = 5000; 
    const updateInterval = 50;  
    const steps = totalDuration / updateInterval;
    const progressIncrement = 1 / steps;

    this.rightProgressInterval = setInterval(() => {
        this.rightProgress = Math.min(this.rightProgress + progressIncrement, 1);
        this.cdr.detectChanges();

        if (this.rightProgress >= 1) {
            clearInterval(this.rightProgressInterval);
            
            this.rightCompleteTimeout = setTimeout(() => {
                this.showRightMessage = false;
                this.rightProgress = 0;
                this.cdr.detectChanges();
            }, 300); 
        }
    }, updateInterval);
}

showWrongResponseMessage() {
    
    clearInterval(this.rightProgressInterval);
    clearInterval(this.wrongProgressInterval);
    clearTimeout(this.wrongCompleteTimeout);
    
    
    this.wrongProgress = 0;
    this.showRightMessage = false;
    this.showWrongMessage = true;
    this.cdr.detectChanges();

    const totalDuration = 5000;
    const updateInterval = 50;
    const steps = totalDuration / updateInterval;
    const progressIncrement = 1 / steps;

    this.wrongProgressInterval = setInterval(() => {
        this.wrongProgress = Math.min(this.wrongProgress + progressIncrement, 1);
        this.cdr.detectChanges();

        if (this.wrongProgress >= 1) {
            clearInterval(this.wrongProgressInterval);
            
            this.wrongCompleteTimeout = setTimeout(() => {
                this.showWrongMessage = false;
                this.wrongProgress = 0;
                this.cdr.detectChanges();
            }, 300); 
        }
    }, updateInterval);
}
}

